import { ShoppbudAPI, XClientSystem } from '@inhouse-market/sdk';
import env from '../env';

const apiSDK = new ShoppbudAPI({
    appVersion: import.meta.env.VITE_VERSION_CODE || '0.0.0-local',
    'x-client-system': XClientSystem.ADMIN,
    async getTokenFn() {
        const authToken =
            localStorage.getItem('@NeerHouse:assumedToken') ||
            localStorage.getItem('@NeerHouse:token');
        return authToken!;
    },
    platformAndVersion: XClientSystem.ADMIN,
    url: env.API_URL,
    userId: localStorage.getItem('@NeerHouse:userId') || '',
});

export default apiSDK;
